module.exports = __webpack_public_path__ + "static/media/speaker-zhixing.0cf0266f.jpg";